const pageNames = Object.freeze({
  homePage: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::home:::',
  },
  callUsPage: {
    pageGroupName: 'main:help:smart::callus',
    pageName: 'main:help:smart::callus:::',
  },
  emailPage: {
    pageGroupName: 'main:help:smart::email',
    pageName: 'main:help:smart::email:::',
  },
  searchPage: {
    pageGroupName: 'main:help:smart::searchPage',
    pageName: 'main:help:smart::searchPage:::',
  },
  intermediatePage: {
    pageGroupName: 'main:help:smart::intermediate',
    pageName: 'main:help:smart::intermediate:::',
  },

  articlePage: {
    pageGroupName: 'main:help:smart::article',
    pageName: 'main:help:smart::article:::',
  },
  topicPage: {
    pageGroupName: 'main:help:smart::topic',
    pageName: 'main:help:smart::topic:::',
  },

  chat: {
    pageGroupName: 'main:help:smart::chat',
    pageName: 'main:help:smart::chat:::',
  },
  hero: {
    pageGroupName: 'main:help:smart::heromodule',
    pageName: 'main:help:smart::heromodule:::',
  },
});

module.exports = {
  pageNames,
};



// WEBPACK FOOTER //
// ./lib/page-name-identifiers.js